import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface LocationSearchLabels {
  titleLabel: string
  titleLabelNaturalLanguage: string
  placeholderLabel: string
  placeholderLabelNaturalLanguage: string
  homesAndVillasPlaceholderLabel: string
}

/**
 * Returns localized labels for location search inputs
 * This hook should be used instead of the deprecated constants in constants/search.ts
 */
function useLocationSearchLabels(): LocationSearchLabels {
  const intl = useIntl()

  return useMemo(() => ({
    titleLabel: intl.formatMessage({
      id: 'EDUnDGM5pV',
      defaultMessage: 'Where',
      description: 'Title label for location search input',
    }),
    titleLabelNaturalLanguage: intl.formatMessage({
      id: '6Uymqdk0HI',
      defaultMessage: 'Search hotels with AI',
      description: 'Title label for natural language location search input',
    }),
    placeholderLabel: intl.formatMessage({
      id: '2ER8z/wIaz',
      defaultMessage: 'Search by destination or hotel',
      description: 'Placeholder for location search input',
    }),
    placeholderLabelNaturalLanguage: intl.formatMessage({
      id: '+0MeZbVxta',
      defaultMessage: "Destination, hotel, or describe what you're after",
      description: 'Placeholder for natural language location search input',
    }),
    homesAndVillasPlaceholderLabel: intl.formatMessage({
      id: '7EylRX/d9i',
      defaultMessage: 'Search by destination or property',
      description: 'Placeholder for homes and villas location search input',
    }),
  }), [intl])
}

export default useLocationSearchLabels
